import { render, staticRenderFns } from "./contactMoments.vue?vue&type=template&id=1d725343&scoped=true&"
import script from "./contactMoments.vue?vue&type=script&lang=js&"
export * from "./contactMoments.vue?vue&type=script&lang=js&"
import style0 from "./contactMoments.vue?vue&type=style&index=0&id=1d725343&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d725343",
  null
  
)

export default component.exports